import { useTranslation } from 'react-i18next'
import LandingServicesCard from "./LandingServicesCard"
import webpage from '../../../assets/images/services/webpage.svg'
import ecommerce from '../../../assets/images/services/ecommerce.svg'
import database from '../../../assets/images/services/database.svg'
import design from '../../../assets/images/services/graphicdesign.svg'

const LandingServices = () => {
    const { t } = useTranslation()

    return (
        <div className="h-max">
            <div className="px-10 py-8">
                <p className="font-semibold sm:pl-10 md:pl-10 lg:pl-10 xl:pl-10">{ t('services') }</p>

                <div className="grid grid-cols-2 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 mt-6">
                    <LandingServicesCard service={'webpages'} link={'/services/websites'} icon={webpage}/>
                    <LandingServicesCard service={'ecommerce'} link={'/services/ecommerce'} icon={ecommerce}/>
                    <LandingServicesCard service={'stock_management'} link={'/services/databases'} icon={database}/>
                    <LandingServicesCard service={'graphic_design'} link={'/services/graphic-design'} icon={design}/>
                </div>
            </div>
        </div>
    )
}

export default LandingServices